import React from 'react'
import styles from './DetailsRow.module.css'
import { CustomFieldsDetailsColumn } from 'components/CustomFields/CustomFieldsColumn'
import { DetailsColumn } from 'components/Order/OrderDetails/OrderPointsList/DetailsColumn'

export function DetailsRow ({ section, children }) {
  return <div className={styles.root}>
    {children}
    <DetailsColumn>
      <CustomFieldsDetailsColumn section={section}/>
    </DetailsColumn>
  </div>
}
